/**
 * Based on: @https://tympanus.net/codrops/2019/10/23/making-gooey-image-hover-effects-with-three-js/
 */

import * as THREE from 'three';
import Figure from './Figure';

const { atan, tan } = Math;
const perspective = 800;
const V_FOV_DEG = (180 * (2 * atan(window.innerHeight / 2 / perspective))) / Math.PI;
const V_FOV_RAD = Math.PI * (V_FOV_DEG / 180);
const TAN_HALF_V_FOV = tan(V_FOV_RAD / 2);

export default class Scene {
    constructor() {
        this.scene = new THREE.Scene();
        this.canvas = document.getElementById('stage');

        this.setWidthAndHeight();

        this.renderer = new THREE.WebGLRenderer({ alpha: false, canvas: this.canvas, antialias: false }); // antialias: true
        this.renderer.setSize(this.width, this.height);
        this.renderer.setPixelRatio(window.devicePixelRatio);

        this.initLights();
        this.initCamera();
        this.onResize();

        this.animationRequestID = false;
        this.figure = new Figure(this.scene);

        window.addEventListener('resize', () => { this.onResize() })
    }

    initLights() {
        const ambientlight = new THREE.AmbientLight(0x808080, -1);
        this.scene.add(ambientlight);
    }

    initCamera() {
        this.camera = new THREE.PerspectiveCamera(V_FOV_DEG, this.width / this.height, 1, 1000);
        this.camera.position.set(0, 0, 0);
    }

    onResize() {
        this.setWidthAndHeight();
        this.camera.aspect = this.width / this.height;
        this.camera.updateProjectionMatrix();

        this.camera.position.z = this.getDistanceFromCamera();
        this.renderer.setSize(this.width, this.height);
    }

    setRun(value) {
        this.run = value;
    }

    start() {
        this.update();
    }

    end() {
        cancelAnimationFrame(this.animationRequestID);
    }

    update(start = false) {
        if(this.renderer === undefined)
            return;

        this.animationRequestID = requestAnimationFrame(this.update.bind(this));
        this.figure.update();
        this.renderer.render(this.scene, this.camera);
    }

    getDistanceFromCamera() {
        const viewAspect = window.innerWidth / window.innerHeight;
        const imgAspect = this.width / this.height;

        return imgAspect > viewAspect ? this.height / (2 * TAN_HALF_V_FOV) : this.width / (2 * tan(this.vfovToHfov(viewAspect) / 2));
    };

    vfovToHfov(aspect) {
        return atan(aspect * TAN_HALF_V_FOV) * 2;
    }

    setWidthAndHeight() {
        if(window.innerWidth >= 992) {
            let container = document.getElementById('apply');
            let {width, height} = container.getBoundingClientRect();
            this.width = width;
            this.height = height;

            this.canvas.style.opacity = 1;
            return;
        }

        this.canvas.style.opacity = 0;
    }
}